import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=4852c0b7"
import script from "./ProjectTasks.vue?vue&type=script&lang=js"
export * from "./ProjectTasks.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasks.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports